export function parseOneSurfaceM2(token: string | number | null | undefined): number | null {
  const cleaned = String(token || '')
    .replace(/\s/g, '')
    .replace(',', '.');
  const n = parseFloat(cleaned.replace(/[^\d.]/g, ''));
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function formatSurfaceRangeDisplay({
  min,
  max,
}: {
  min?: number | null;
  max?: number | null;
} = {}): string {
  if (min == null) return '';
  const fmt = (n: number) =>
    new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 }).format(Math.round(n));
  if (max != null && max > min) return `${fmt(min)} à ${fmt(max)} m²`;
  return `${fmt(min)} m²`;
}

export function parseSurfaceRangeInput(raw: string | number | null | undefined): {
  min: number | null;
  max: number | null;
  display: string;
} {
  const original = String(raw ?? '').trim();
  if (!original) {
    return { min: null, max: null, display: '' };
  }

  const withoutUnit = original
    .replace(/\s*(m²|m2|m\s*²)\s*$/gi, '')
    .replace(/\s*(m²|m2|m\s*²)\s*/gi, ' ')
    .trim();

  const rangeMatch = withoutUnit.match(
    /^(?:de\s+)?(\d[\d\s.,]*)\s*(?:à|a|–|-|\/|\s+\/\s+)\s*(\d[\d\s.,]*)/i,
  );
  if (rangeMatch) {
    const min = parseOneSurfaceM2(rangeMatch[1]);
    const max = parseOneSurfaceM2(rangeMatch[2]);
    if (min != null && max != null) {
      return {
        min,
        max: max > min ? max : null,
        display: formatSurfaceRangeDisplay({ min, max: max > min ? max : null }),
      };
    }
  }

  const single = parseOneSurfaceM2(withoutUnit.match(/(\d[\d\s.,]*)/)?.[1] ?? withoutUnit);
  if (single != null) {
    return { min: single, max: null, display: formatSurfaceRangeDisplay({ min: single }) };
  }

  return { min: null, max: null, display: original };
}

export function resolveListingSurfaceRange(listing: {
  surface?: number | string | null;
  surfaceMinM2?: number | null;
  surfaceMaxM2?: number | null;
  vitrineContent?: {
    surface?: string;
    surfaceMinM2?: number | null;
    surfaceMaxM2?: number | null;
  } | null;
}): { min: number | null; max: number | null } {
  const c = listing.vitrineContent;
  const minStored =
    typeof listing.surfaceMinM2 === 'number' && listing.surfaceMinM2 > 0
      ? listing.surfaceMinM2
      : typeof c?.surfaceMinM2 === 'number' && c.surfaceMinM2 > 0
        ? c.surfaceMinM2
        : null;
  const maxStored =
    typeof listing.surfaceMaxM2 === 'number' && listing.surfaceMaxM2 > 0
      ? listing.surfaceMaxM2
      : typeof c?.surfaceMaxM2 === 'number' && c.surfaceMaxM2 > 0
        ? c.surfaceMaxM2
        : null;

  if (minStored != null) {
    return {
      min: minStored,
      max: maxStored != null && maxStored > minStored ? maxStored : null,
    };
  }

  const parsed = parseSurfaceRangeInput(c?.surface ?? listing.surface);
  return { min: parsed.min, max: parsed.max };
}
